import {MessageContentFormat} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {normalizeEmailHtml} from './normalizeEmailHtml';

/**
 * The body and its format, which always travel together.
 *
 * `bodyFormat` is optional on every request type that accepts it, so a site that normalized the
 * body and forgot the flag would compile and the customer would receive visible tags.
 */
export function toEmailBodyPayload(body: string | Nullish): {
  body: string;
  bodyFormat: MessageContentFormat;
} {
  return {body: normalizeEmailHtml(body), bodyFormat: 'html'};
}
